export default __webpack_public_path__ + "static/img2-da5e568f42607c9b5bf11eb4ef5f89df.jpeg";